<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p50"><span><a id="page_38"></a><a href="#/Contents#rp50">VIDALIA ONION SOUP</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>The mild sweetness of Vidalia onions makes this soup special, but try it with other flavorful onion varieties too.</i></span></p>
<p class="make"><span>8 first-course servings</span></p>
<p class="hang"><span>6 cups thinly sliced Vidalia onions</span></p>
<p class="hang"><span>2 cloves garlic, minced</span></p>
<p class="hang"><span>1 teaspoon sugar</span></p>
<p class="hang"><span>⅓ cup all-purpose flour</span></p>
<p class="hang"><span>6 cups reduced-sodium fat-free chicken or vegetable broth</span></p>
<p class="hang"><span>1½ teaspoons dried sage leaves</span></p>
<p class="hang"><span>2 bay leaves</span></p>
<p class="hang"><span>Salt and white pepper, to taste</span></p>
<p class="hang"><span>Snipped chives or sliced green onions, as garnish</span></p>
<p class="normalt"><span><b>1.</b> Cook onions and garlic in lightly greased large saucepan, covered, over medium-low heat until softened, 8 to 10 minutes. Stir in sugar and continue cooking, uncovered, until onions are lightly browned, about 10 minutes. Stir in flour; cook 1 minute. Add broth and herbs; heat to boiling. Reduce heat and simmer, covered, 30 minutes. Discard bay leaves. Process half the soup in food processor or blender until smooth; return to saucepan and season to taste with salt and white pepper. Serve warm or chilled; sprinkle each bowl of soup with chives.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 88</span></p>
<p class="per1"><span>% calories from fat: 3</span></p>
<p class="per1"><span>Protein (g): 2.2</span></p>
<p class="per1"><span>Carbohydrate (g): 16.4</span></p>
<p class="per1"><span>Fat (g): 0.3</span></p>
<p class="per1"><span>Saturated fat (g): 0.1</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 13</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.5</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
<p class="normalt"><span><span class="small">VARIATION</span></span></p>
<p class="normala" id="p50a"><span><b>Baked Onion Soup with Sun-Dried Tomato Pesto</b> — Make soup as above, adding ¼ cup dry sherry in Step 2. Spread 8 Bruschetta (see <span href="#/Chapter132#p850" title="Link target outside of Sample">p. 637</span>) with ½ cup Sun-Dried Tomato Pesto (see <span href="#/Chapter1334#p882" title="Link target outside of Sample">p. 662</span>). Place in bottoms of 8 oven-proof soup bowls and sprinkle with 1 cup shredded reduced-fat Italian-blend cheese. Ladle soup over and bake at 425 degrees, 10 to 15 minutes, or until cheese is melted.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0231.vue?2fbf2fa9